import { EmailUtils } from '../utils/genericUtils.js'

export const FILE_FLAG_OPTIONS = {
  correctFormat: 'correctFormat',
  incorrectFormat: 'incorrectFormat',
  errorOnItems: 'errorOnItems',
}

class ErrorType {
  code = ''
  message = ''

  constructor({ code, message } = {}) {
    this.code = code
    this.message = message
  }
}

const COLLABORATOR_FIELD_ERRORS = {
  email: {
    code: 'email',
    message: 'Correo inválido',
  },
  updatedEmail: {
    code: 'updatedEmail',
    message: 'Correo inválido',
  },
  role: {
    code: 'role',
    message: 'Rol inválido',
  },
  firstName: {
    code: 'firstName',
    message: 'Nombre inválido',
  },
  lastName: {
    code: 'lastName',
    message: 'Apellido inválido',
  },
}

export const COLLABORATOR_ERRORS = {
  email: COLLABORATOR_FIELD_ERRORS.email.code,
  updatedEmail: COLLABORATOR_FIELD_ERRORS.updatedEmail.code,
  role: COLLABORATOR_FIELD_ERRORS.role.code,
  lastName: COLLABORATOR_FIELD_ERRORS.lastName.code,
  firstName: COLLABORATOR_FIELD_ERRORS.firstName.code,
}

const STUDENT_FIELD_ERRORS = {
  level: new ErrorType({
    code: 'level',
    message: 'Nivel inválido o inexistente',
  }),
  firstName: new ErrorType({
    code: 'firstName',
    message: 'Nombre inválido',
  }),
  lastName: new ErrorType({
    code: 'lastName',
    message: 'Apellido inválido',
  }),
  gender: new ErrorType({
    code: 'gender',
    message: 'Género inválido',
  }),
  personId: new ErrorType({
    code: 'personId',
    message: 'Matrícula inválida',
  }),
  personIdRepeated: new ErrorType({
    code: 'personIdRepeated',
    message: 'Matrícula repetida',
  }),
  updatedPersonId: new ErrorType({
    code: 'updatedPersonId',
    message: 'Matrícula nueva inválida',
  }),
  updatedPersonIdRepeated: new ErrorType({
    code: 'updatedPersonIdRepeated',
    message: 'Matrícula nueva repetida',
  }),
  grade: new ErrorType({
    code: 'grade',
    message: 'Grado inválido',
  }),
  group: new ErrorType({
    code: 'group',
    message: 'Grupo inválido',
  }),
  parents: new ErrorType({
    code: 'parents',
    message: 'Tutores inválidos',
  }),
  parent_firstName: new ErrorType({
    code: 'parent_firstName',
    message: 'Nombre inválido',
  }),
  parent_lastName: new ErrorType({
    code: 'parent_lastName',
    message: 'Apellido inválido',
  }),
  parent_email: new ErrorType({
    code: 'parent_email',
    message: 'Correo inválido',
  }),
}

export const STUDENT_ERRORS = {
  level: STUDENT_FIELD_ERRORS.level.code,
  lastName: STUDENT_FIELD_ERRORS.lastName.code,
  firstName: STUDENT_FIELD_ERRORS.firstName.code,
  gender: STUDENT_FIELD_ERRORS.gender.code,
  personId: STUDENT_FIELD_ERRORS.personId.code,
  personIdRepeated: STUDENT_FIELD_ERRORS.personIdRepeated.code,
  updatedPersonId: STUDENT_FIELD_ERRORS.updatedPersonId.code,
  updatedPersonIdRepeated: STUDENT_FIELD_ERRORS.updatedPersonIdRepeated.code,
  grade: STUDENT_FIELD_ERRORS.grade.code,
  group: STUDENT_FIELD_ERRORS.group.code,
  parents: STUDENT_FIELD_ERRORS.parents.code,
  parent_firstName: STUDENT_FIELD_ERRORS.parent_firstName.code,
  parent_lastName: STUDENT_FIELD_ERRORS.parent_lastName.code,
  parent_email: STUDENT_FIELD_ERRORS.parent_email.code,
}

export const MASSIVE_UPLOAD_UPGRADE_RESPONSE = {
  id: 0,
  createdAt: 1696435287503,
  updateExisting: false,
  removeMissing: false,
  created: 0,
  updated: 0,
  removed: 0,
  ignored: 0,
  skipped: 0,
}
export class CollaboratorModel {
  // defaultErrorMessage = 'Colaborador con campos inválidos'

  constructor(
    {
      id,
      lastName = '',
      firstName = '',
      email = '',
      updatedEmail = '',
      webRole = new Role(),
      // errorMessage = undefined,
      status,
      errors,
    } = {
      id,
      lastName: '',
      firstName: '',
      email: '',
      updatedEmail: '',
      webRole,
      // errorMessage: '',
      status: '',
      errors: '',
    }
  ) {
    this.id = id
    this.lastName = lastName
    this.email = email
    this.updatedEmail = updatedEmail
    this.firstName = firstName
    this.webRole = new Role(webRole)
    // this.errorMessage = errorMessage
    this.fieldErrors = new Map()
    // this.errorOnCollaborator = false
    this.status = status
    this.errors = errors
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(array, (e) => new CollaboratorModel(e))
  }
}

class Level {
  constructor({ id, Nivel, Grado, Grupo } = {}) {
    this.id = id
    this.level = Nivel
    this.grade = Grado
    this.group = Grupo
  }
}

export class Parent {
  fieldErrors = new Map()
  errorOnParent = false
  defaultErrorMessage = 'Tutor con campos inválidos'
  errorMessage = ''

  constructor({ Nombre_Tutor, Apellido_Tutor, Correo_Tutor } = {}) {
    this.id = crypto.randomUUID()
    this.firstName = Nombre_Tutor
    this.lastName = Apellido_Tutor
    this.mail = Correo_Tutor
  }

  clearErrors() {
    this.fieldErrors.clear()
    return this
  }

  /**
   *
   * @param {ErrorType} error
   */
  hasError(error) {
    return this.fieldErrors.has(STUDENT_FIELD_ERRORS[error].code)
  }

  /**
   *
   * @param {STUDENT_ERRORS} error
   */
  getError(error) {
    if (this.fieldErrors.has(error) === false) return ''

    return this.fieldErrors.get(error)
  }

  _trimValues() {
    Object.entries(this).forEach(([k, v]) => {
      if (typeof v === 'number') {
        this[k] = v.toString().trim()
      }
      if (v !== undefined && typeof v === 'string') {
        this[k] = v.trim()
      }
    })
    return this
  }
}

export class StudentModel {
  constructor(student) {
    this.id = student.id
    this.firstName = student.firstName
    this.lastName = student.lastName
    this.personId = student.personId
    this.updatedPersonId = student.updatedPersonId
    this.level = student.level
    this.gg = student.gg
    this.parents = student.parents
    this.gender = student.gender
    this.grade = student.grade
    this.groupName = student.groupName

    this.status = student.status
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(array, (e) => new StudentModel(e))
  }
}

export class XlsxFrontStudentAdapter {
  defaultErrorMessage = 'Estudiante con campos inválidos'

  /**
   * @type {Array<Parent>}
   */
  parents = []

  personId = ''

  constructor(student) {
    this.id = crypto.randomUUID()
    this.firstName = student.Nombre
    this.lastName = student.Apellidos
    this.errorMessage = ''
    this.fieldErrors = new Map()
    this.errorOnStudent = false

    this.gender = student.Genero
    this.personId = student.Matricula
    this.updatedPersonId = student.Matricula_Nueva
    this.level = new Level({ Nivel: student.Nivel })

    this.gg = new Level({
      Grado:
        typeof student.Grado === 'number'
          ? student.Grado.toString()
          : student.Grado,
      Grupo:
        typeof student.Grupo === 'number'
          ? student.Grupo.toString()
          : student.Grupo,
    })

    this._setParents(student)
    this._setGender()
  }

  addParent(parent) {
    this.parents.push(parent)
  }

  /**
   *
   * @param {Parent} parent
   */
  removeParent(parent) {
    this.parents = this.parents.filter((e) => e.id !== parent.id)
  }

  _getParentIndex(key, regex, cb) {
    if (new RegExp(regex).test(key)) {
      let index = ''
      for (let i = 0; i < key.length; i++) {
        const el = key[i]
        if (!isNaN(el)) {
          index = index.concat(el)
        }
      }
      cb(Number(index) - 1)
    }
  }

  _setParents(student) {
    const temp = Object.entries(student)
    /**
     * @type {Array<Parent>}
     */
    const tempParents = []

    for (let i = 0; i < temp.length; i++) {
      const [k, v] = temp[i]

      this._getParentIndex(k, /^Nombre_Tutor\d*$/, (index) => {
        if (tempParents[index] === undefined) {
          tempParents[index] = new Parent()
        }
        tempParents[index].firstName = v
      })
      this._getParentIndex(k, /^Apellido_Tutor\d*$/, (index) => {
        if (tempParents[index] === undefined) {
          tempParents[index] = new Parent()
        }
        tempParents[index].lastName = v
      })
      this._getParentIndex(k, /^Correo_Tutor\d*$/, (index) => {
        if (tempParents[index] === undefined) {
          tempParents[index] = new Parent()
        }
        tempParents[index].mail = v
      })
    }
    this.parents = tempParents
  }

  /**
   *
   * @param {ErrorType} type
   */
  _setFieldError(type) {
    this.fieldErrors.set(type.code, type.message)
  }

  /**
   * @param {Parent} parent
   * @param {ErrorType} type
   */
  _setParentFieldError(parent, type) {
    parent.fieldErrors.set(type.code, type.message)
  }

  setupLevels(levels) {
    for (let i = 0; i < levels.length; i++) {
      const el = levels[i]
      if (this.level.level === el.typeLevel) {
        this.level.id = el.id
      }
    }
  }

  _setGender() {
    if (typeof this.gender !== 'string') {
      this.gender = 'Masculino'
      return
    }

    if (this.gender.trim().toLowerCase() === 'Masculino'.toLowerCase()) {
      this.gender = 'Masculino'
    }

    if (this.gender.trim().toLowerCase() === 'Femenino'.toLowerCase()) {
      this.gender = 'Femenino'
    }
  }

  validate() {
    this._trimValues()
      ._validateLevel()
      ._validateFirstName()
      ._validateLastName()
      ._validateGender()
      ._validateGradeGroup()
      ._validatePersonId()
      ._validateUpdatedPersonId()
      ._removeEmptyParents()
      ._validateParents()
    // this._validateLevel()
    // this._validateFirstName()
    // this._validateLastName()
    // this._validateGender()
    // this._validateGradeGroup()
    // this._validatePersonId()
    // this._validateUpdatedPersonId()
    // this._validateParents()

    this.errorOnStudent = this._hasSomeError(this.fieldErrors)

    if (this.errorOnStudent) {
      this.errorMessage = this.defaultErrorMessage
    }
  }

  clearErrors() {
    this.fieldErrors.clear()
  }

  /**
   *
   * @param {ErrorType} error
   */
  hasError(error) {
    return this.fieldErrors.has(STUDENT_FIELD_ERRORS[error].code)
  }

  /**
   *
   * @param {STUDENT_ERRORS} error
   */
  getError(error) {
    if (this.fieldErrors.has(error) === false) return ''

    return this.fieldErrors.get(error)
  }

  /**
   * @param {Map} map
   * @returns {boolean}
   */
  _hasSomeError(map) {
    return map.size != 0
  }

  _trimValues() {
    Object.entries(this).forEach(([k, v]) => {
      if (typeof v === 'number') {
        this[k] = v.toString().trim()
      }
      if (v !== undefined && typeof v === 'string') {
        this[k] = v.trim()
      }
    })
    return this
  }

  _validateLevel() {
    if (this.level.id === undefined) {
      this._setFieldError(STUDENT_FIELD_ERRORS.level)
      return this
    }
    return this
  }

  /**
   * Validations
   * - is string
   * - is defined
   * - max char allowed
   * - is not empty
   *
   * @param {string} value
   * @param {number} maxChar
   * @returns {boolean}
   */
  _isInvalidString(value, maxChar = 50) {
    const isNotString = typeof value != 'string'
    const isUndefined = value === undefined

    if (isNotString || isUndefined) {
      return true
    }

    const maxCharAllowed = maxChar
    const exeedCharAllowed = value.length > maxCharAllowed
    const isEmpty = typeof value === 'string' && value.trim() === ''

    return isEmpty || exeedCharAllowed
  }

  _isInvalidEmail(email, maxChar = 255) {
    const isNotString = typeof email != 'string'
    const isUndefined = email === undefined
    if (isNotString || isUndefined) return true

    const maxCharAllowed = maxChar
    const exeedCharAllowed = email.length > maxCharAllowed
    const isEmpty = typeof email === 'string' && email.trim() === ''
    const isInvalidEmail = EmailUtils.isValidEmail(email) === false

    return isEmpty || exeedCharAllowed || isInvalidEmail
  }

  _validateFirstName() {
    if (this._isInvalidString(this.firstName, 50)) {
      this._setFieldError(STUDENT_FIELD_ERRORS.firstName)
    }
    return this
  }

  _validateLastName() {
    if (this._isInvalidString(this.lastName, 50)) {
      this._setFieldError(STUDENT_FIELD_ERRORS.lastName)
    }
    return this
  }

  _validateGender() {
    if (this._isInvalidString(this.gender, 10)) {
      this._setFieldError(STUDENT_FIELD_ERRORS.gender)
    }

    if (this.gender !== 'Masculino' && this.gender !== 'Femenino') {
      this._setFieldError(STUDENT_FIELD_ERRORS.gender)
    }
    return this
  }

  _validateGradeGroup() {
    if (this._isInvalidString(this.gg.grade, 45)) {
      this._setFieldError(STUDENT_FIELD_ERRORS.grade)
    }

    if (this._isInvalidString(this.gg.group, 45)) {
      this._setFieldError(STUDENT_FIELD_ERRORS.group)
    }
    return this
  }

  setInvalidPersonId(isUpdated = false) {
    if (isUpdated) {
      this._setFieldError(STUDENT_FIELD_ERRORS.updatedPersonIdRepeated)
      return
    }

    this._setFieldError(STUDENT_FIELD_ERRORS.personIdRepeated)
  }

  _validatePersonId() {
    if (this._isInvalidString(this.personId, 100)) {
      this._setFieldError(STUDENT_FIELD_ERRORS.personId)
    }
    return this
  }

  _validateUpdatedPersonId() {
    if (
      typeof this.updatedPersonId === 'string' &&
      this.updatedPersonId.trim() === ''
    ) {
      this.updatedPersonId = undefined
    }

    if (this.updatedPersonId === undefined) return this

    if (this._isInvalidString(this.updatedPersonId, 100)) {
      this._setFieldError(STUDENT_FIELD_ERRORS.updatedPersonId)
    }

    return this
  }

  _removeEmptyParents() {
    if (this.parents.length === 0) {
      this._setFieldError(STUDENT_FIELD_ERRORS.parents)
      return this
    }

    this.parents = this.parents.filter(
      (e) =>
        e.lastName &&
        e.lastName !== '' &&
        e.firstName &&
        e.firstName !== '' &&
        e.mail &&
        e.mail !== '' &&
        Object.values(e).length !== 0
    )
    return this
  }

  _validateParents() {
    // REMOVE POSSIBLE EMPTY ELEMENTS
    if (this.parents.length === 0) {
      this._setFieldError(STUDENT_FIELD_ERRORS.parents)
      return this
    }

    for (let i = 0; i < this.parents.length; i++) {
      // const parent = this.parents[i]
      this.parents[i].clearErrors()._trimValues()
      this._validateParent(this.parents[i])
    }

    return this
  }

  /**
   *
   * @param {Parent} parent
   */
  _validateParent(parent) {
    const invalidEmail = this._isInvalidEmail(parent.mail)
    const invalidFirstName = this._isInvalidString(parent.firstName, 60)
    const invalidLastName = this._isInvalidString(parent.lastName, 100)

    if (invalidEmail || invalidFirstName || invalidLastName) {
      this._setFieldError(STUDENT_FIELD_ERRORS.parents)
    }
    if (invalidEmail) {
      this._setParentFieldError(parent, STUDENT_FIELD_ERRORS.parent_email)
    }
    if (invalidFirstName) {
      this._setParentFieldError(parent, STUDENT_FIELD_ERRORS.parent_firstName)
    }
    if (invalidLastName) {
      this._setParentFieldError(parent, STUDENT_FIELD_ERRORS.parent_lastName)
    }

    parent.errorOnParent = this._hasSomeError(parent.fieldErrors)

    if (parent.errorOnParent) {
      parent.errorMessage = parent.defaultErrorMessage
    }
  }

  removeId() {
    this.id = undefined
    return this
  }

  removeParentIds() {
    for (const parent of this.parents) {
      parent.id = undefined
    }
    return this
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(array, (e) => new XlsxFrontStudentAdapter(e))
  }

  toStudentModel() {
    this.level.level = undefined

    if (this.gender === 'Masculino') {
      this.gender = 'MALE'
    } else if (this.gender === 'Femenino') {
      this.gender = 'FEMALE'
    } else {
      this.gender = this.gender
    }

    return new StudentModel(this)
  }
}

class XlsxFrontCollaboratorAdapter {
  defaultErrorMessage = 'Colaborador con campos inválidos'

  constructor(
    {
      id = Math.random(),
      Apellidos = '',
      Nombre = '',
      Correo = '',
      Correo_Nuevo = '',
      Rol = new Role(),
      errorMessage = undefined,
    } = {
      id,
      Apellidos: '',
      Nombre: '',
      Correo: '',
      Correo_Nuevo: '',
      Rol: undefined,
      errorMessage: '',
    }
  ) {
    this.id = id
    this.lastName = Apellidos
    this.email = Correo
    this.updatedEmail = Correo_Nuevo
    this.firstName = Nombre
    this.webRole = Rol
    this.errorMessage = errorMessage
    this.fieldErrors = new Map()
    this.errorOnCollaborator = false
  }

  /**
   *
   * @param {COLLABORATOR_ERRORS} error
   */
  hasError(error) {
    return this.fieldErrors.has(COLLABORATOR_FIELD_ERRORS[error].code)
  }

  /**
   *
   * @param {COLLABORATOR_ERRORS} error
   */
  getError(error) {
    if (this.fieldErrors.has(error) === false) return 'error'

    return this.fieldErrors.get(error)
  }

  hasSomeError() {
    return this.fieldErrors.size != 0
  }

  _clearErrors() {
    this.fieldErrors.clear()
  }

  validateRole(roles = []) {
    if (roles.includes(this.webRole.name) === false) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.role.code,
        COLLABORATOR_FIELD_ERRORS.role.message
      )
    }
  }

  /**
   *
   * @param {{ string:Array<Role> }}  rolesGroupByName
   */
  setupRoleId(rolesGroupByName = []) {
    if (this.fieldErrors.has(COLLABORATOR_FIELD_ERRORS.role.code)) return

    this.webRole = rolesGroupByName[this.webRole.name]
  }

  validateEmail() {
    const maxCharAllowed = 255
    const exeedCharAllowed = this.email.length > maxCharAllowed
    const isNotString = typeof this.email != 'string'
    const isUndefined = this.email === undefined
    const isEmpty = typeof this.email === 'string' && this.email.trim() === ''
    const isInvalidEmail = EmailUtils.isValidEmail(this.email) === false

    if (
      isNotString ||
      isUndefined ||
      isEmpty ||
      exeedCharAllowed ||
      isInvalidEmail
    ) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.email.code,
        COLLABORATOR_FIELD_ERRORS.email.message
      )
    }
  }

  validateUpdatedEmail() {
    const maxCharAllowed = 255
    const exeedCharAllowed = this.updatedEmail.length > maxCharAllowed
    const isNotString = typeof this.updatedEmail != 'string'
    const isUndefined = this.updatedEmail === undefined
    const isEmpty =
      typeof this.updatedEmail === 'string' && this.updatedEmail.trim() === ''
    const isInvalidEmail = EmailUtils.isValidEmail(this.updatedEmail) === false
    const hasNoEmail = this.hasError(COLLABORATOR_ERRORS.updatedEmail) === false

    if (hasNoEmail && isEmpty) return

    if (
      isNotString ||
      isUndefined ||
      isEmpty ||
      exeedCharAllowed ||
      isInvalidEmail
    ) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.updatedEmail.code,
        COLLABORATOR_FIELD_ERRORS.updatedEmail.message
      )
    }
  }

  validateFirstName() {
    const isNotString = typeof this.firstName != 'string'
    const isUndefined = this.firstName === undefined
    const isEmpty =
      typeof this.firstName === 'string' && this.firstName.trim() === ''

    if (isNotString || isUndefined || isEmpty) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.firstName.code,
        COLLABORATOR_FIELD_ERRORS.firstName.message
      )
    }
  }

  validateLastName() {
    const isNotString = typeof this.lastName != 'string'
    const isUndefined = this.lastName === undefined
    const isEmpty =
      typeof this.lastName === 'string' && this.lastName.trim() === ''

    if (isNotString || isUndefined || isEmpty) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.lastName.code,
        COLLABORATOR_FIELD_ERRORS.lastName.message
      )
    }
  }

  /**
   *
   * @param {Array<Role>} roles
   * @param {Array<string>} rolesNames
   * @param {{ string:Array<Role> }} rolesGroupByName
   */
  validate(rolesNames = [], rolesGroupByName = []) {
    this._clearErrors()
    this.validateEmail()
    this.validateUpdatedEmail()
    this.validateFirstName()
    this.validateLastName()
    this.validateRole(rolesNames)
    this.setupRoleId(rolesGroupByName)

    this.errorOnCollaborator = this.hasSomeError()

    if (this.errorOnCollaborator) {
      this.errorMessage = this.defaultErrorMessage
    }
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(
      array,
      (e) => new XlsxFrontCollaboratorAdapter({ ...e, Rol: { name: e.Rol } })
    )
  }
}

class Role {
  constructor(
    { hierachy = 0, id = Math.random(), name = '' } = {
      hierachy: 0,
      id: 0,
      name: '',
    }
  ) {
    this.hierachy = hierachy
    this.id = id
    this.name = name
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(array, (e) => new Role(e))
  }
}

export async function loadCollaborator(files, possibleRoles) {
  // console.log(possibleRoles)
  const roles = Role.fromArray(possibleRoles)
  const rolesNames = roles.map((e) => e.name)
  const rolesGroupByName = _groupBy(roles, ({ name }) => name)

  // console.log(roles)

  const { headers, bodyJson } = await new Promise((res, _) => {
    const filerReader = new FileReader()
    filerReader.onload = () => {
      res(parseXlsxToJson(filerReader.result))
    }

    filerReader.readAsArrayBuffer(files[0])
  })

  // console.log(headers)
  // console.log(bodyJson)

  const requiredHeaders = ['Nombre', 'Apellidos', 'Correo', 'Rol']
  const isValidHeaders = validateHeaders(requiredHeaders, headers)

  if (isValidHeaders === false) {
    return {
      collaborators: [],
      fileError: true,
      collaboratorsError: [],
    }
  }

  const collaborators = XlsxFrontCollaboratorAdapter.fromArray(bodyJson)
  const collaboratorsError = []
  // console.log(collaborators)

  for (let i = 0; i < collaborators.length; i++) {
    const collaborator = collaborators[i]
    collaborator.validate(rolesNames, rolesGroupByName)
    if (collaborator.errorOnCollaborator === true) {
      collaboratorsError.push(collaborator)
    }
  }

  return {
    collaborators: collaborators,
    fileError: false,
    collaboratorsError: collaboratorsError,
  }
}

export async function loadStudendtsParentsXlsx(files, levels) {
  const { headers, bodyJson } = await new Promise((res, _) => {
    const filerReader = new FileReader()
    filerReader.onload = () => {
      res(parseXlsxToJson(filerReader.result))
    }

    filerReader.readAsArrayBuffer(files[0])
  })

  const requiredHeaders = [
    'Nombre',
    'Apellidos',
    'Genero',
    'Nivel',
    'Grado',
    'Grupo',
    'Matricula',
    'Nombre_Tutor1',
    'Apellido_Tutor1',
    'Correo_Tutor1',
  ]

  const isValidHeaders = validateHeaders(requiredHeaders, headers)

  if (isValidHeaders === false) {
    return {
      students: [],
      fileError: true,
      studentsError: [],
    }
  }

  const { students, studentsError, someStudentHasSomeError } = handleStudents(
    bodyJson,
    levels
  )

  return {
    students: students,
    fileError: false,
    studentsError: studentsError,
    someStudentHasSomeError: someStudentHasSomeError,
  }
}

export function handleStudents(jsonStudents, levels) {
  const students = XlsxFrontStudentAdapter.fromArray(jsonStudents)
  const studentsError = new Set()

  /**
   * single student validation
   */
  for (let i = 0; i < students.length; i++) {
    const student = students[i]
    student.setupLevels(levels)
    student.validate()
    if (student.errorOnStudent === true) {
      studentsError.add(student)
    }
  }

  class StudentPersonIds {
    current = []
    updated = []
  }

  const existentStudentsPersonIds = {}
  students.forEach((el) => {
    if (existentStudentsPersonIds.hasOwnProperty(el.personId)) {
      existentStudentsPersonIds[el.personId].current.push(el.id)

      if (el.updatedPersonId !== undefined) {
        existentStudentsPersonIds[el.updatedPersonId].updated.push(el.id)
      }
    } else {
      const temp = new StudentPersonIds()
      temp.current.push(el.id)

      existentStudentsPersonIds[el.personId] = temp

      if (el.updatedPersonId !== undefined) {
        temp.updated.push(el.id)
        existentStudentsPersonIds[el.updatedPersonId] = temp
      }
    }
  })

  const current = students.map((e) => [e.id, e.personId])
  const updated = students
    .filter((e) => e.updatedPersonId !== undefined)
    .map((e) => [e.id, e.updatedPersonId])

  students.forEach((student) => {
    const countIds = current.filter((e) => e[1] === student.personId).length
    const countIdsUpdated = updated.filter(
      (e) => e[1] === student.updatedPersonId
    ).length

    if (countIds > 1) {
      student.setInvalidPersonId()
    }
    if (countIdsUpdated > 1) {
      student.setInvalidPersonId(true)
    }

    student.validate()
    if (student.errorOnStudent === true) {
      studentsError.add(student)
    }
  })

  const parsedSortedStudentsError = Array.from(studentsError).sort((a, b) => {
    if (a.firstName < b.firstName) return -1
    if (a.firstName > b.firstName) return 1
    return 0
  })

  return {
    students,
    /**
     * @type {Array<XlsxFrontStudentAdapter>}
     */
    studentsError: parsedSortedStudentsError,
    someStudentHasSomeError: Array.from(studentsError).length !== 0,
  }
}

/**
 *
 * @param {Array<XlsxFrontCollaboratorAdapter>} collaborators
 * @param {Array<XlsxFrontCollaboratorAdapter>} errorCollaborators
 * @returns
 */
export function validateParsedCollaborators(
  collaborators,
  errorCollaborators,
  rawPossibleRoles
) {
  const roles = Role.fromArray(rawPossibleRoles)
  const rolesNames = roles.map((e) => e.name)
  const rolesGroupByName = _groupBy(roles, ({ name }) => name)
  // console.log(roles)
  // console.log(errorCollaborators)
  // const tempCollaborators = collaborators.map((e) => structuredClone(e))
  const tempCollaborators = collaborators
  const collaboratorsError = []

  errorCollaborators.forEach((collab) => {
    const indexCollaborator = collaborators.findIndex((e) => e.id === collab.id)
    collaborators[indexCollaborator] = collab
  })

  for (let i = 0; i < collaborators.length; i++) {
    const collaborator = collaborators[i]
    collaborator.validate(rolesNames, rolesGroupByName)
    if (collaborator.errorOnCollaborator === true) {
      collaboratorsError.push(collaborator)
    }
  }

  return {
    collaborators: tempCollaborators,
    fileError: false,
    collaboratorsError: collaboratorsError,
  }
}

/**
 *
 * @param {Array<XlsxFrontStudentAdapter>} students
 * @param {Array<XlsxFrontStudentAdapter>} errorStudents
 */
export function validateParsedStudents(students, errorStudents, levels) {
  const {
    students: tempStudents,
    studentsError,
    someStudentHasSomeError,
  } = handleParsedStudents(students, errorStudents, levels)

  return {
    students: tempStudents,
    studentsError: studentsError,
    someStudentHasSomeError: someStudentHasSomeError,
  }
}

/**
 *
 * @param {Array<XlsxFrontStudentAdapter>} students
 * @param {Array<XlsxFrontStudentAdapter>} errorStudents
 */
export function handleParsedStudents(students, errorStudents, levels) {
  const studentsError = new Set()

  errorStudents.forEach((student) => {
    const indexStudent = students.indexOf((e) => e.id === student.id)
    students[indexStudent] = student
  })

  for (let i = 0; i < students.length; i++) {
    const student = students[i]
    student.clearErrors()
    student.setupLevels(levels)
  }

  const current = students.map((e) => [e.id, e.personId])
  const updated = students
    .filter((e) => e.updatedPersonId !== undefined)
    .map((e) => [e.id, e.updatedPersonId])

  students.forEach((student) => {
    const countIds = current.filter((e) => e[1] === student.personId).length
    const countIdsUpdated = updated.filter(
      (e) => e[1] === student.updatedPersonId
    ).length

    if (countIds > 1) {
      student.setInvalidPersonId()
    }
    if (countIdsUpdated > 1) {
      student.setInvalidPersonId(true)
    }

    student.validate()
    if (student.errorOnStudent === true) {
      studentsError.add(student)
    }
  })

  const parsedSortedStudentsError = Array.from(studentsError).sort((a, b) => {
    if (a.firstName < b.firstName) return -1
    if (a.firstName > b.firstName) return 1
    return 0
  })

  return {
    students,
    /**
     * @type {Array<XlsxFrontStudentAdapter>}
     */
    studentsError: parsedSortedStudentsError,
    someStudentHasSomeError: Array.from(studentsError).length !== 0,
  }
}

function validateHeaders(requiredHeaders = [], headers = []) {
  return requiredHeaders.map((e) => headers.includes(e)).every(Boolean)
}

function parseXlsxToJson(rawData) {
  const XLSX = require('xlsx')
  const data = new Uint8Array(rawData)
  const tempArray = new Array()
  for (let i = 0; i != data.length; ++i) {
    tempArray[i] = String.fromCharCode(data[i])
  }
  const bstr = tempArray.join('')
  // Call XLSX
  const workbook = XLSX.read(bstr, {
    type: 'binary',
  })
  // DO SOMETHING WITH workbook HERE
  const first_sheet_name = workbook.SheetNames[0]
  // Get worksheet
  const worksheet = workbook.Sheets[first_sheet_name]
  //Get "Headers", first row from first sheet
  const cells = XLSX.utils.sheet_to_formulae(worksheet)
  const headerRegex = new RegExp("^([A-Za-z]+)1='(.*)$")
  const headers = cells
    .filter((item) => headerRegex.test(item))
    .map((item) => item.split("='")[1])

  const collaboratorsXlsxMadeJson = XLSX.utils.sheet_to_json(worksheet, {
    raw: true,
  })
  return {
    headers: headers,
    bodyJson: collaboratorsXlsxMadeJson,
  }
}

function _groupBy(array, callback) {
  const tempObj = {}
  for (let i = 0; i < array.length; i++) {
    const el = array[i]
    const val = callback(el)
    tempObj[val] = el
  }

  return tempObj
}
